import { render, staticRenderFns } from "./selectFontFamily.vue?vue&type=template&id=6e21174d&scoped=true"
import script from "./selectFontFamily.vue?vue&type=script&lang=js"
export * from "./selectFontFamily.vue?vue&type=script&lang=js"
import style0 from "./selectFontFamily.vue?vue&type=style&index=0&id=6e21174d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e21174d",
  null
  
)

export default component.exports